/* ROCKY SPORT — rk14 ana sayfa: hero slider + tam ekran video izleyici */
(() => {
  'use strict';
  if (window.__ROCKY_RK14_HOME__) return;
  window.__ROCKY_RK14_HOME__ = true;

  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = n => String(n).padStart(2, '0');

  /* ---------------------------------------------------------------
     HERO SLIDER
  --------------------------------------------------------------- */
  const initHero = hero => {
    if (hero.dataset.rk14Ready === 'true') return;
    const track = hero.querySelector('[data-rk14-track]');
    const slides = [...hero.querySelectorAll('[data-rk14-slide]')];
    if (!track || !slides.length) return;
    hero.dataset.rk14Ready = 'true';

    const dots = [...hero.querySelectorAll('[data-rk14-dot]')];
    const prev = hero.querySelector('[data-rk14-prev]');
    const next = hero.querySelector('[data-rk14-next]');
    const interval = Math.max(2000, Number(hero.dataset.interval) || 5000);
    const autoplay = hero.dataset.autoplay === 'true' && slides.length > 1;

    let index = 0;
    let timer = 0;
    let raf = 0;
    const pauseReasons = new Set();

    const currentIndex = () => Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / (track.clientWidth || 1))));

    const syncVideos = () => {
      slides.forEach((slide, i) => {
        const video = slide.querySelector('[data-rk14-video]');
        if (!video) return;
        if (i === index && !reduceMotion() && !pauseReasons.has('hidden') && !pauseReasons.has('offscreen')) {
          if (!video.getAttribute('src') && video.dataset.src) video.src = video.dataset.src;
          video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          video.play().catch(() => {});
        } else if (video.getAttribute('src')) {
          video.pause();
        }
      });
    };

    const setActive = i => {
      if (i === index && slides[i].classList.contains('is-active')) return;
      index = i;
      slides.forEach((slide, n) => slide.classList.toggle('is-active', n === i));
      dots.forEach((dot, n) => {
        dot.classList.toggle('is-active', n === i);
        if (n === i) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      syncVideos();
    };

    const goTo = (i, wrap = true) => {
      let target = i;
      if (wrap) target = (i + slides.length) % slides.length;
      else target = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: target * track.clientWidth, behavior: reduceMotion() ? 'auto' : 'smooth' });
      setActive(target);
    };

    const stopTimer = () => { window.clearTimeout(timer); timer = 0; };
    const schedule = () => {
      stopTimer();
      if (!autoplay || pauseReasons.size) return;
      timer = window.setTimeout(() => goTo(index + 1), interval);
    };
    const pause = reason => { pauseReasons.add(reason); stopTimer(); };
    const resume = reason => { pauseReasons.delete(reason); schedule(); };

    track.addEventListener('scroll', () => {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(() => {
        setActive(currentIndex());
        schedule();
      });
    }, { passive: true });

    prev?.addEventListener('click', () => { goTo(index - 1); schedule(); });
    next?.addEventListener('click', () => { goTo(index + 1); schedule(); });
    dots.forEach(dot => dot.addEventListener('click', () => { goTo(Number(dot.dataset.rk14Dot) || 0); schedule(); }));

    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(index - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(index + 1); }
    });

    /* duraklatma kaynakları */
    hero.addEventListener('mouseenter', () => pause('hover'));
    hero.addEventListener('mouseleave', () => resume('hover'));
    hero.addEventListener('touchstart', () => pause('touch'), { passive: true });
    hero.addEventListener('touchend', () => window.setTimeout(() => resume('touch'), 1200), { passive: true });
    hero.addEventListener('touchcancel', () => resume('touch'), { passive: true });
    hero.addEventListener('focusin', () => pause('focus'));
    hero.addEventListener('focusout', () => resume('focus'));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) pause('hidden');
      else { pauseReasons.delete('hidden'); syncVideos(); schedule(); }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) { pauseReasons.delete('offscreen'); syncVideos(); schedule(); }
          else { pauseReasons.add('offscreen'); stopTimer(); syncVideos(); }
        });
      }, { threshold: 0.25 }).observe(hero);
    }

    /* masaüstü fare ile sürükleme */
    let dragging = false;
    let moved = false;
    let startX = 0;
    let startScroll = 0;
    let lastDx = 0;
    track.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      dragging = true;
      moved = false;
      lastDx = 0;
      startX = event.clientX;
      startScroll = track.scrollLeft;
    });
    window.addEventListener('pointermove', event => {
      if (!dragging) return;
      const dx = event.clientX - startX;
      if (!moved && Math.abs(dx) > 5) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) {
        lastDx = dx;
        track.scrollLeft = startScroll - dx;
      }
    });
    const endDrag = () => {
      if (!dragging) return;
      dragging = false;
      if (!moved) return;
      track.classList.remove('is-dragging');
      const base = Math.round(startScroll / (track.clientWidth || 1));
      const threshold = Math.min(90, track.clientWidth * 0.12);
      let target = base;
      if (lastDx < -threshold) target = base + 1;
      else if (lastDx > threshold) target = base - 1;
      goTo(target, false);
      schedule();
    };
    window.addEventListener('pointerup', endDrag);
    window.addEventListener('pointercancel', endDrag);
    track.addEventListener('click', event => {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }, true);
    track.addEventListener('dragstart', event => event.preventDefault());

    /* tema editörü */
    hero.addEventListener('shopify:block:select', event => {
      const slide = event.target.closest('[data-rk14-slide]');
      if (!slide) return;
      pause('editor');
      track.scrollTo({ left: slides.indexOf(slide) * track.clientWidth, behavior: 'auto' });
      setActive(slides.indexOf(slide));
    });
    hero.addEventListener('shopify:block:deselect', () => resume('editor'));

    syncVideos();
    schedule();
  };

  /* ---------------------------------------------------------------
     TAM EKRAN VİDEO İZLEYİCİ
  --------------------------------------------------------------- */
  let viewerApi = null;

  const buildViewer = () => {
    if (viewerApi) return viewerApi;

    const root = document.createElement('div');
    root.className = 'rk14-viewer';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-label', 'Rocky video hikâyeleri');
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML = `
      <div class="rk14-viewer__backdrop" data-backdrop></div>
      <div class="rk14-viewer__frame">
        <div class="rk14-viewer__stage" data-stage>
          <video class="rk14-viewer__video" playsinline webkit-playsinline preload="metadata"></video>
        </div>
        <div class="rk14-viewer__top">
          <div class="rk14-viewer__bars" data-bars></div>
          <div class="rk14-viewer__tools">
            <span class="rk14-viewer__count" data-count></span>
            <span class="rk14-viewer__btns">
              <button type="button" class="rk14-viewer__btn" data-sound aria-pressed="false" aria-label="Sesi kapat">
                <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 9v6h4l5 4V5L8 9H4z"/><g class="rk14-viewer__on"><path d="M16.5 8.5a5 5 0 0 1 0 7"/><path d="M19 6a8.5 8.5 0 0 1 0 12"/></g><g class="rk14-viewer__off"><path d="M17 9l5 6M22 9l-5 6"/></g></svg>
              </button>
            </span>
          </div>
        </div>
        <div class="rk14-viewer__info">
          <p class="rk14-viewer__eyebrow" data-eyebrow></p>
          <h2 class="rk14-viewer__title" data-title></h2>
          <a class="rk14-viewer__cta" data-cta href="#" hidden></a>
        </div>
      </div>
      <button type="button" class="rk14-viewer__btn rk14-viewer__close" data-close aria-label="Kapat">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
      <button type="button" class="rk14-viewer__btn rk14-viewer__nav rk14-viewer__nav--prev" data-prev aria-label="Önceki video">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M15 5l-7 7 7 7"/></svg>
      </button>
      <button type="button" class="rk14-viewer__btn rk14-viewer__nav rk14-viewer__nav--next" data-next aria-label="Sonraki video">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 5l7 7-7 7"/></svg>
      </button>`;
    document.body.appendChild(root);

    const $ = selector => root.querySelector(selector);
    const video = $('video');
    const bars = $('[data-bars]');
    const count = $('[data-count]');
    const sound = $('[data-sound]');
    const title = $('[data-title]');
    const eyebrow = $('[data-eyebrow]');
    const cta = $('[data-cta]');
    const backdrop = $('[data-backdrop]');

    let cards = [];
    let index = 0;
    let opener = null;
    let muted = false;

    const syncSound = () => {
      video.muted = muted;
      sound.classList.toggle('is-muted', muted);
      sound.setAttribute('aria-pressed', String(!muted));
      sound.setAttribute('aria-label', muted ? 'Sesi aç' : 'Sesi kapat');
    };

    const play = () => {
      const attempt = video.play();
      if (!attempt || typeof attempt.catch !== 'function') return;
      attempt.catch(() => {
        if (!muted) {
          muted = true;
          syncSound();
          video.play().catch(() => {});
        }
      });
    };

    const paintBars = () => {
      [...bars.children].forEach((bar, n) => {
        bar.classList.toggle('is-done', n < index);
        bar.firstElementChild.style.transform = n === index ? 'scaleX(0)' : '';
      });
    };

    const show = i => {
      index = (i + cards.length) % cards.length;
      const card = cards[index];
      const data = card.dataset;
      video.pause();
      video.poster = data.image || '';
      backdrop.style.setProperty('--rk14-bg', data.image ? `url("${data.image.replace(/"/g, '%22')}")` : 'none');
      video.src = data.video || '';
      video.loop = false;
      syncSound();
      video.load();
      count.textContent = `${pad(index + 1)} / ${pad(cards.length)}`;
      eyebrow.textContent = data.eyebrow || '';
      title.textContent = data.title || '';
      if (data.url) {
        cta.href = data.url;
        cta.textContent = data.cta || 'Ürünü gör';
        cta.hidden = false;
      } else {
        cta.hidden = true;
      }
      paintBars();
      play();
    };

    const focusables = () => [...root.querySelectorAll('button, a[href]')].filter(el => !el.hidden && el.offsetParent !== null);

    const close = () => {
      if (!root.classList.contains('is-open')) return;
      video.pause();
      video.removeAttribute('src');
      video.load();
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('rk14-lock');
      opener?.focus?.({ preventScroll: true });
    };

    const open = (list, i, trigger) => {
      cards = list;
      opener = trigger;
      bars.replaceChildren(...cards.map(() => {
        const bar = document.createElement('span');
        bar.className = 'rk14-viewer__bar';
        bar.append(document.createElement('i'));
        return bar;
      }));
      cards.forEach(card => card.querySelectorAll('video').forEach(v => v.pause()));
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('rk14-lock');
      show(i);
      $('[data-close]').focus({ preventScroll: true });
    };

    $('[data-close]').addEventListener('click', close);
    backdrop.addEventListener('click', close);
    $('[data-prev]').addEventListener('click', () => show(index - 1));
    $('[data-next]').addEventListener('click', () => show(index + 1));
    sound.addEventListener('click', () => { muted = !muted; syncSound(); if (video.paused) play(); });

    video.addEventListener('timeupdate', () => {
      const bar = bars.children[index];
      if (bar && video.duration) bar.firstElementChild.style.transform = `scaleX(${Math.min(1, video.currentTime / video.duration)})`;
    });
    video.addEventListener('ended', () => show(index + 1));

    root.addEventListener('keydown', event => {
      if (!root.classList.contains('is-open')) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      else if (event.key === 'ArrowLeft') show(index - 1);
      else if (event.key === 'ArrowRight') show(index + 1);
      else if (event.key === 'Tab') {
        const items = focusables();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('keydown', event => {
      if (root.classList.contains('is-open') && event.key === 'Escape') close();
    });

    /* dokunma hareketleri: yana kaydır = önceki/sonraki, aşağı kaydır = kapat, dokun = duraklat/oynat */
    let gesture = null;
    const stage = $('[data-stage]');
    stage.addEventListener('pointerdown', event => {
      gesture = { x: event.clientX, y: event.clientY };
    });
    stage.addEventListener('pointerup', event => {
      if (!gesture) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
      else if (dy > 90 && dy > Math.abs(dx)) close();
      else if (Math.abs(dx) < 10 && Math.abs(dy) < 10) {
        if (video.paused) play();
        else video.pause();
      }
    });
    stage.addEventListener('pointercancel', () => { gesture = null; });

    viewerApi = { open, close };
    return viewerApi;
  };

  /* ---------------------------------------------------------------
     İNCE KAYDIRMA GÖSTERGESİ (mobil; CSS masaüstünde gizler)
     JS yoksa hiç eklenmez, liste yine kaydırılabilir kalır.
  --------------------------------------------------------------- */
  const initProgress = (scroller, host) => {
    if (!scroller || !host || scroller.dataset.rk14Progress === 'true') return;
    scroller.dataset.rk14Progress = 'true';

    const track = document.createElement('span');
    track.className = 'rk14-progress is-idle';
    track.setAttribute('aria-hidden', 'true');
    const thumb = document.createElement('i');
    track.append(thumb);
    host.append(track);

    let raf = 0;
    const update = () => {
      raf = 0;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const hasMore = max > 4;
      track.classList.toggle('is-idle', !hasMore);
      scroller.classList.toggle('rk14-has-more', hasMore && scroller.scrollLeft < max - 4);
      const trackWidth = track.clientWidth;
      if (!hasMore || !trackWidth) return;
      const width = Math.min(trackWidth, Math.max(16, trackWidth * (scroller.clientWidth / scroller.scrollWidth)));
      const ratio = Math.min(1, Math.max(0, scroller.scrollLeft / max));
      thumb.style.width = `${width.toFixed(1)}px`;
      thumb.style.transform = `translateX(${((trackWidth - width) * ratio).toFixed(1)}px)`;
    };
    const schedule = () => {
      if (!raf) raf = window.requestAnimationFrame(update);
    };

    scroller.addEventListener('scroll', schedule, { passive: true });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(scroller);
      observer.observe(track);
      [...scroller.children].forEach(child => observer.observe(child));
    } else {
      window.addEventListener('resize', schedule);
    }
    window.addEventListener('load', schedule, { once: true });
    schedule();
  };

  const initCats = section => {
    const list = section.querySelector('.rk14-cats__list');
    initProgress(list, list?.parentElement);
  };

  const initReels = section => {
    if (section.dataset.rk14Ready === 'true') return;
    const cards = [...section.querySelectorAll('[data-rk14-reel-card]')];
    if (!cards.length) return;
    section.dataset.rk14Ready = 'true';
    cards.forEach((card, i) => {
      card.querySelector('[data-rk14-reel-open]')?.addEventListener('click', event => {
        event.preventDefault();
        buildViewer().open(cards, i, event.currentTarget);
      });
    });

    /* kaydırma çubuğu yerine oklar + noktalar */
    const rail = section.querySelector('.rk4-reels__rail');
    const prev = section.querySelector('[data-rk14-reels-prev]');
    const next = section.querySelector('[data-rk14-reels-next]');
    const dotsWrap = section.querySelector('[data-rk14-reels-dots]');
    if (!rail) return;
    initProgress(rail, section.querySelector('[data-rk14-reels-controls]'));
    const dots = dotsWrap ? cards.map(() => document.createElement('i')) : [];
    dotsWrap?.replaceChildren(...dots);

    let raf = 0;
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const left = rail.scrollLeft;
      if (prev) prev.disabled = left <= 4;
      if (next) next.disabled = max <= 4 || left >= max - 4;
      if (dots.length) {
        const step = cards.length > 1 ? (cards[1].offsetLeft - cards[0].offsetLeft) || 1 : 1;
        const active = max <= 4 ? 0 : left >= max - 4 ? cards.length - 1 : Math.round(left / step);
        dots.forEach((dot, n) => dot.classList.toggle('is-active', n === Math.min(active, cards.length - 1)));
      }
    };
    const scrollByPage = dir => {
      const step = (cards[1] ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth) || 280;
      const perPage = Math.max(1, Math.floor(rail.clientWidth / step));
      rail.scrollBy({ left: dir * step * perPage, behavior: reduceMotion() ? 'auto' : 'smooth' });
    };
    prev?.addEventListener('click', () => scrollByPage(-1));
    next?.addEventListener('click', () => scrollByPage(1));
    rail.addEventListener('scroll', () => {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', () => {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(sync);
    });
    sync();
  };

  /* ince "aşağıdan yukarı" giriş; hareket azaltma açıksa veya IO yoksa hiçbir şey yapmaz */
  const initFx = scope => {
    if (reduceMotion() || !('IntersectionObserver' in window)) return;
    /* FAQ (.rk11-aeo__inner) yalnızca ana sayfada canlanır; ürün sayfasında bu dosya sadece reels için yüklenir */
    const faq = document.body.classList.contains('rk4-product-page') ? '' : ', .rk11-aeo__inner';
    const targets = scope.querySelectorAll(`.rk14-cats, .rk4-home .rk4-products .rk4-headline, .rk4-home .rk4-products__footer, .rk14-reels-scope .rk4-reels .rk4-headline, .rk14-reels-scope .rk4-reels__rail${faq}`);
    if (!targets.length) return;
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(el => {
      if (el.dataset.rk14Fx) return;
      el.dataset.rk14Fx = '1';
      el.classList.add('rk14-fx');
      io.observe(el);
    });
    window.setTimeout(() => targets.forEach(el => el.classList.add('is-in')), 4000);
  };

  /* güven şeridi: dokunurken duraklat */
  const initTrust = trust => {
    if (trust.dataset.rk14Ready === 'true') return;
    trust.dataset.rk14Ready = 'true';
    let t = 0;
    trust.addEventListener('touchstart', () => { window.clearTimeout(t); trust.classList.add('is-paused'); }, { passive: true });
    const end = () => { window.clearTimeout(t); t = window.setTimeout(() => trust.classList.remove('is-paused'), 800); };
    trust.addEventListener('touchend', end, { passive: true });
    trust.addEventListener('touchcancel', end, { passive: true });
  };

  const init = root => {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-rk14-trust]').forEach(initTrust);
    initFx(scope);
    if (scope.matches?.('[data-rk14-hero]')) initHero(scope);
    scope.querySelectorAll('[data-rk14-hero]').forEach(initHero);
    if (scope.matches?.('[data-rk14-reels]')) initReels(scope);
    scope.querySelectorAll('[data-rk14-reels]').forEach(initReels);
    if (scope.matches?.('[data-rk14-cats]')) initCats(scope);
    scope.querySelectorAll('[data-rk14-cats]').forEach(initCats);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => viewerApi?.close());
})();

/* Performans: gizli ürün sekmeleri <template> içinde gelir; sekme açıldığında oluşturulur */
(() => {
  const hydrate = panel => {
    const tpl = panel.querySelector(':scope > template[data-rk14-lazy]');
    if (!tpl) return;
    panel.replaceChildren(tpl.content.cloneNode(true));
    panel.querySelectorAll('[data-rk4-reveal]').forEach(el => { el.dataset.rk4Observed = 'true'; el.classList.add('is-visible'); });
    document.dispatchEvent(new CustomEvent('rocky:products-loaded', { detail: { root: panel } }));
  };
  const watch = root => {
    (root || document).querySelectorAll('.rk4-product-panel').forEach(panel => {
      if (panel.dataset.rk14Lazy || !panel.querySelector(':scope > template[data-rk14-lazy]')) return;
      panel.dataset.rk14Lazy = '1';
      if (!panel.hidden) { hydrate(panel); return; }
      new MutationObserver((list, mo) => { if (!panel.hidden) { mo.disconnect(); hydrate(panel); } })
        .observe(panel, { attributes: true, attributeFilter: ['hidden'] });
      // Kullanıcı sekmeye uzanınca (hover/dokunma) önceden hazırla — tıklamada gecikme hissedilmesin
      const tab = document.querySelector(`[aria-controls="${panel.id}"]`);
      ['pointerenter', 'touchstart', 'focus'].forEach(ev => tab?.addEventListener(ev, () => hydrate(panel), { once: true, passive: true }));
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => watch(), { once: true });
  else watch();
  document.addEventListener('shopify:section:load', e => watch(e.target));
})();
